module.exports = __webpack_public_path__ + "static/og_image-2ca51de441de7de3ac952d72642153b9.jpg";